const UNITS_ATTRIBUTES = {
  //getRoomAttributes
  UNITS_ROOM_ATTRIBUTES: 'UNITS_ROOM_ATTRIBUTES',
  //getUnitAttributes
  UNITS_UNIT_ATTRIBUTES: 'UNITS_UNIT_ATTRIBUTES',
  //getUnitAttributesTranslations
  UNITS_UNIT_ATTRIBUTES_TRANSLATIONS: 'UNITS_UNIT_ATTRIBUTES_TRANSLATIONS',
};

export default UNITS_ATTRIBUTES;
